__webpack_require__.p = "https://assets-01.periodica.press/d916028-23348269782/";